import { getApi } from "../helper";

/* eslint-disable prefer-destructuring */

const  mode = window.location.host;

const api = getApi(mode)
// console.log('mode',mode)
export const BASE_URL = api.base_url
export const IMAGE_URL = api.img_url
export const APP_URL = api.app_url
export const PUBLIC_URL = process.env.PUBLIC_URL;